// extracted by mini-css-extract-plugin
export default {"product":"Product_product__BslQj","productInfo":"Product_productInfo__H6yu0","addToCartButton":"Product_addToCartButton__6wL-U"};